/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Topsection_Tba1Inputs */

const id_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const ms_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const da_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const de_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N.N.`)
};

const en_us2_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const es_es2_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const es_mx2_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente`)
};

const fil_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const fr_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À déterminer`)
};

const it_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da annunciare`)
};

const hu_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Később`)
};

const nl_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog te bepalen`)
};

const no_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunngjøres`)
};

const pl_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const pt_br2_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const pt_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A definir`)
};

const ro_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const fi_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const sv_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const vi_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẽ công bố`)
};

const tr_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belirtilecek`)
};

const cs_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bude oznámeno`)
};

const bg_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ще бъде обявено`)
};

const ru_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будет объявлено`)
};

const uk_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уточнюється`)
};

const ar_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيُحدد لاحقًا`)
};

const hi_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घोषित होना बाकी`)
};

const th_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จะแจ้งภายหลัง`)
};

const ja_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未定`)
};

const zh_cn2_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const zh_hant1_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

const ko_components_topsection_tba1 = /** @type {(inputs: Components_Topsection_Tba1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBA`)
};

/**
* | output |
* | --- |
* | "TBA" |
*
* @param {Components_Topsection_Tba1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_topsection_tba1 = /** @type {((inputs?: Components_Topsection_Tba1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Topsection_Tba1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_topsection_tba1(inputs)
	if (locale === "ms") return ms_components_topsection_tba1(inputs)
	if (locale === "da") return da_components_topsection_tba1(inputs)
	if (locale === "de") return de_components_topsection_tba1(inputs)
	if (locale === "en-US") return en_us2_components_topsection_tba1(inputs)
	if (locale === "es-ES") return es_es2_components_topsection_tba1(inputs)
	if (locale === "es-MX") return es_mx2_components_topsection_tba1(inputs)
	if (locale === "fil") return fil_components_topsection_tba1(inputs)
	if (locale === "fr") return fr_components_topsection_tba1(inputs)
	if (locale === "it") return it_components_topsection_tba1(inputs)
	if (locale === "hu") return hu_components_topsection_tba1(inputs)
	if (locale === "nl") return nl_components_topsection_tba1(inputs)
	if (locale === "no") return no_components_topsection_tba1(inputs)
	if (locale === "pl") return pl_components_topsection_tba1(inputs)
	if (locale === "pt-BR") return pt_br2_components_topsection_tba1(inputs)
	if (locale === "pt") return pt_components_topsection_tba1(inputs)
	if (locale === "ro") return ro_components_topsection_tba1(inputs)
	if (locale === "fi") return fi_components_topsection_tba1(inputs)
	if (locale === "sv") return sv_components_topsection_tba1(inputs)
	if (locale === "vi") return vi_components_topsection_tba1(inputs)
	if (locale === "tr") return tr_components_topsection_tba1(inputs)
	if (locale === "cs") return cs_components_topsection_tba1(inputs)
	if (locale === "bg") return bg_components_topsection_tba1(inputs)
	if (locale === "ru") return ru_components_topsection_tba1(inputs)
	if (locale === "uk") return uk_components_topsection_tba1(inputs)
	if (locale === "ar") return ar_components_topsection_tba1(inputs)
	if (locale === "hi") return hi_components_topsection_tba1(inputs)
	if (locale === "th") return th_components_topsection_tba1(inputs)
	if (locale === "ja") return ja_components_topsection_tba1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_topsection_tba1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_topsection_tba1(inputs)
	return ko_components_topsection_tba1(inputs)
});
export { components_topsection_tba1 as "components.topSection.tba" }